import Vue from 'vue';

const state = {
	templates: [],
	templates_loading: false
};

const getters = {
	templates: state => {
		return state.templates;
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Performance Review Templates...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/performanceReviewTemplates`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	add({ commit, dispatch, rootState }, performanceReviewTemplate) {
		console.log('Adding New Performance Review Template...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/performanceReviewTemplates`, performanceReviewTemplate)
				.then(resp => {
					commit('ADD_SUCCESS', performanceReviewTemplate);
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error saving Performance Review Template');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, performanceReviewTemplate) {
		console.log('Updating Performance Review Template...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/performanceReviewTemplates/${performanceReviewTemplate.id}`, performanceReviewTemplate)
				.then(resp => {
					commit('EDIT_SUCCESS', performanceReviewTemplate);
					dispatch('get');
					resolve(performanceReviewTemplate);
				})
				.catch(err => {
					console.log('Error updating Performance Review Template');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, performanceReviewTemplate) {
		console.log('Deleting Performance Review Template...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/performanceReviewTemplates/${performanceReviewTemplate.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', performanceReviewTemplate);
					dispatch('get');
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Performance Review Template');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.templates_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.templates_loading = false;
		state.templates = data;
	},
	GET_FAILURE(state, error) {
		state.templates_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.templates.push(data);
	},
	EDIT_SUCCESS(state, data) {
		let found = state.templates.find(pr => pr.id === data.id);
		if (found != null) {
			found = data;
		}
	},
	DELETE_SUCCESS(state, data) {
		const index = state.templates.indexOf(data);
		state.templates.splice(index, 1);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
